import React, { useState } from 'react';
import { FormControl, Select, MenuItem, ListItemIcon } from '@mui/material';
import {
	ECOMMERCE,
	OMNI,
	STORE,
	BOGLE_REGULAR,
	ECOM,
} from '../../constants/constant';
import { colors } from '../../theme/color-palette';
import OMNISVG from '../../assets/SVGs/omni.svg';
import ECOMSVG from '../../assets/SVGs/ecommerce.svg';
import STORESVG from '../../assets/SVGs/store.svg';
import STORESVG_DISABLED from '../../assets/SVGs/store-disabled.svg';

import { useStyles, selectStyleMenu } from './styles';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const ChannelFilter = ({ onFilterClick, selectedFilter }) => {
	const classes = useStyles();
	const [openMenu, setOpenMenu] = useState(false);
	const { PURPLE } = colors;

	const location = useLocation();

	return (
		<FormControl className={classes.formControl} size="small">
			<Select
				data-test="channel-dropdown"
				id="channel-dropdown"
				disabled={location?.pathname?.includes('/dashboard/guided-insights')}
				value={selectedFilter === ECOM ? ECOMMERCE : selectedFilter}
				onChange={onFilterClick}
				onOpen={() => setOpenMenu(true)}
				onClose={() => setOpenMenu(false)}
				className={openMenu ? classes.onFocus : ''}
				sx={{
					fontFamily: BOGLE_REGULAR,
					fontSize: '14px !important',
					height: '32px',
					'& .MuiSelect-select': {
						fontFamily: BOGLE_REGULAR,
						display: 'flex',
						alignItems: 'center',
					},
					'& .MuiSvgIcon-root': {
						color: PURPLE,
					},
					'& .Mui-disabled': {
						color: '#BABBBE',
					},
				}}
				MenuProps={{
					sx: selectStyleMenu,
					disablePortal: true,
				}}>
				<MenuItem
					data-test="OMNI"
					value={OMNI}
					sx={{
						fontSize: 14,
						fontFamily: BOGLE_REGULAR,
						display: 'block !important',
						padding: '6px 16px !important',
					}}>
					<ListItemIcon sx={{ minWidth: '20px' }}>
						<img src={OMNISVG} alt="Omni Icon"></img>
					</ListItemIcon>
					{OMNI}
				</MenuItem>
				<MenuItem
					data-test="STORE"
					value={STORE}
					sx={{
						fontSize: 14,
						fontFamily: BOGLE_REGULAR,
						display: 'block !important',
						padding: '6px 16px !important',
					}}>
					<ListItemIcon
						sx={{
							minWidth: '20px',
						}}>
						<img
							src={
								location?.pathname?.includes('/dashboard/guided-insights')
									? STORESVG_DISABLED
									: STORESVG
							}
							style={{
								color: PURPLE,
							}}
							alt="Store Icon"></img>
					</ListItemIcon>
					{STORE}
				</MenuItem>
				<MenuItem
					data-test="ECOM"
					value={ECOMMERCE}
					sx={{
						fontSize: 14,
						fontFamily: BOGLE_REGULAR,
						display: 'block !important',
						padding: '6px 16px !important',
					}}>
					<ListItemIcon sx={{ minWidth: '20px' }}>
						<img src={ECOMSVG} alt="ECOM Icon"></img>
					</ListItemIcon>
					{ECOMMERCE}
				</MenuItem>
			</Select>
		</FormControl>
	);
};

ChannelFilter.propTypes = {
	onFilterClick: PropTypes.func,
	selectedFilter: PropTypes.string,
};

export default ChannelFilter;
